var _path, _ellipse, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserFriendly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 66,
    viewBox: "0 0 82 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.813 60.593L36.813 60.5931C37.1287 61.5897 36.965 62.5475 36.3268 63.3942C35.687 64.2429 34.7835 64.6943 33.6862 64.6943H4.53082C3.43354 64.6943 2.53004 64.2429 1.89029 63.3942C1.25208 62.5476 1.08848 61.5897 1.4041 60.593C3.73647 53.2276 10.7701 47.8527 19.1086 47.8527C27.4473 47.8527 34.4807 53.2274 36.813 60.593ZM80.5392 60.593L80.5393 60.5931C80.8549 61.5897 80.6913 62.5475 80.053 63.3942C79.4133 64.2429 78.5098 64.6943 77.4125 64.6943H48.2572C47.16 64.6943 46.2565 64.2429 45.6167 63.3942C44.9785 62.5476 44.8149 61.5897 45.1305 60.593C47.4629 53.2276 54.4966 47.8527 62.8349 47.8527C71.1735 47.8527 78.207 53.2274 80.5392 60.593ZM40.9717 23.462C44.8178 23.462 48.3857 24.6051 51.3435 26.56C49.8298 28.7388 48.9419 31.3736 48.9419 34.2115C48.9419 36.4016 49.4708 38.4712 50.4083 40.3036H31.5353C32.4728 38.4712 33.0017 36.4017 33.0017 34.2115C33.0017 31.3736 32.1138 28.7388 30.6001 26.56C33.5579 24.6051 37.1258 23.462 40.9717 23.462ZM54.0854 34.2117C54.0854 29.5274 57.9763 25.6826 62.835 25.6826C67.6938 25.6826 71.5847 29.5274 71.5847 34.2117C71.5847 38.896 67.6938 42.7407 62.835 42.7407C57.9763 42.7407 54.0854 38.896 54.0854 34.2117ZM10.3589 34.2117C10.3589 29.5274 14.2499 25.6826 19.1086 25.6826C23.9673 25.6826 27.8583 29.5274 27.8583 34.2117C27.8583 38.896 23.9673 42.7407 19.1086 42.7407C14.2499 42.7407 10.3589 38.896 10.3589 34.2117ZM40.9719 1.29199C45.8306 1.29199 49.7216 5.13672 49.7216 9.82104C49.7216 14.5053 45.8307 18.3501 40.9719 18.3501C36.1132 18.3501 32.2222 14.5053 32.2222 9.82104C32.2222 5.13672 36.1132 1.29199 40.9719 1.29199Z",
    stroke: "#092E40",
    strokeWidth: 2.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.498,
    cy: 33.8551,
    rx: 8.5,
    ry: 8.48741,
    fill: "#092E40"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.498,
    cy: 9.89025,
    rx: 8.5,
    ry: 8.48741,
    fill: "#092E40"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.498,
    cy: 33.8551,
    rx: 8.5,
    ry: 8.48741,
    fill: "#092E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFriendly);
export default __webpack_public_path__ + "static/media/user-friendly.c6de140b7364bc910cbc7dabbe1ea9fe.svg";
export { ForwardRef as ReactComponent };